var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.button.type
    ? _c("play-button", {
        staticClass: "overflow-hidden",
        attrs: {
          type: _vm.button.type,
          title: _vm.button.a11y,
          color: _vm.background,
          background: _vm.color,
          size: _vm.size,
          label: _vm.button.label,
          "data-test": "play-button"
        },
        on: { click: _vm.dispatch },
        nativeOn: {
          mouseover: function($event) {
            return _vm.mouseOver($event)
          },
          mouseleave: function($event) {
            return _vm.mouseLeave($event)
          }
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }